module.exports = __webpack_public_path__ + "fonts/GOTHICB0.7bea0c92.TTF";